module.exports = __webpack_public_path__ + "ai.no2.9541abe2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/aoyama/child_to_parent/ai.no2.jpg
// module id = 5UVO
// module chunks = 0